import React from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'

import ExceptMobile from './ExceptMobile/ExceptMobile'
import Mobile from './Mobile/Mobile'

import s from './FooterView.scss'


const FooterView = ({ collectEmailFormNode, data, isAddressVisible, isLandings }) => (
  <footer className={s.footer}>
    <Media mobile>
      {
        (isMobile) => React.createElement(isMobile ? Mobile : ExceptMobile, {
          collectEmailFormNode,
          ...data,
          isAddressVisible,
          isLandings,
        })
      }
    </Media>
  </footer>
)

FooterView.propTypes = {
  collectEmailFormNode: PropTypes.node,
  data: PropTypes.shape({
    logoLink: PropTypes.string,
    about: PropTypes.shape({
      title: PropTypes.object.isRequired,
      nav: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.object.isRequired,
        to: PropTypes.string,
        toOLD: PropTypes.string,
      })).isRequired,
    }).isRequired,
    shop: PropTypes.shape({
      title: PropTypes.object.isRequired,
      nav: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.object.isRequired,
        to: PropTypes.string,
        toOLD: PropTypes.string,
      })).isRequired,
    }).isRequired,
  }),
  isAddressVisible: PropTypes.bool,
}


export default FooterView
